import React from 'react';
import { Edit, Cancel, SendTwoTone } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { Grid, Typography, TextField, Tooltip, IconButton, InputAdornment, Box } from '@mui/material';

import UploadFile from '../../sections/chat/file/UploadFile';

export default function ChatInput({
  user,
  body,
  preBody,
  setBody,
  postNewChat,
  cancelEdit,
  chatIdToBeEdited,
  targetType,
  targetId
}) {
  return (
    <Grid item xs={12} sm={12} sx={{ mt: 7 }}>
      <Box>
        {((user && user.role.permissions.publicChat.create && targetType === 'public') ||
          (user && user.role.permissions.personalChat.create && targetType === 'personal') ||
          (user && user.role.permissions.ownRoleChat.create && targetType === 'role') ||
          (user && user.role.permissions.ownDistrictChat.create && targetType === 'district') ||
          (user && user.role.permissions.ownChurchChat.create && targetType === 'church') ||
          (user && user.role.permissions.ownCategoryChat.create && targetType === 'category')) && (
            <>
              {chatIdToBeEdited && (
                <Box display="flex" justifyContent="space-between">
                  <Typography color="text.secondary" noWrap>
                    <Edit color="warning" sx={{ fontSize: '18px' }} /> | {preBody}
                  </Typography>
                  <Tooltip title="ተመለስ">
                    <IconButton>
                      <Cancel onClick={cancelEdit} color="error" sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              <TextField
                value={body}
                multiline
                fullWidth
                maxRows={3}
                onChange={(e) => setBody(e.target.value)}
                placeholder="እዚህ ጻፍ..."
                autoFocus={chatIdToBeEdited !== null}
                InputProps={{
                  startAdornment: (
                    <Box sx={{ flexDirection: 'row' }}>
                      {/* <EmojiPicker /> */}
                      <UploadFile
                        user={user}
                        body={body}
                        preBody={preBody}
                        setBody={setBody}
                        postNewChat={postNewChat}
                        cancelEdit={cancelEdit}
                        chatIdToBeEdited={chatIdToBeEdited}
                        targetId={targetId}
                        targetType={targetType}
                      />
                    </Box>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="ለጥፍ">
                        <IconButton
                          type="submit"
                          onClick={postNewChat}
                          color="primary"
                          disabled={body === null || body === ''}
                          sx={{ fontSize: 40 }}
                        >
                          <SendTwoTone sx={{ fontSize: 35 }} />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </>
          )}
      </Box>
    </Grid>
  );
}

ChatInput.propTypes = {
  user: PropTypes.object.isRequired,
  body: PropTypes.string.isRequired,
  preBody: PropTypes.string.isRequired,
  setBody: PropTypes.func.isRequired,
  postNewChat: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
  chatIdToBeEdited: PropTypes.string.isRequired,
  targetType: PropTypes.string.isRequired,
  targetId: PropTypes.string.isRequired,
};
